import { render, staticRenderFns } from "./Invoice.List.vue?vue&type=template&id=ff9cb66e&"
import script from "./Invoice.List.vue?vue&type=script&lang=js&"
export * from "./Invoice.List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports